import { CountryMagentoResponse } from "../../country-selector/country.interface";

export const mapCountryMagentoResponse = (countries: CountryMagentoResponse[]) => {
  return countries.reduce((response, country) => {
    if (country.full_name_english) {
      response[country.id] = country.full_name_english;
    }
    return response;
  }, {});
};

export const mapCountryStateMagentoResponse = (country: CountryMagentoResponse) => {
  return country?.available_regions?.reduce((response, state) => {
    response[state.code] = state.name;
    return response;
  }, {});
};
